import { render, staticRenderFns } from "./QuestionsView.vue?vue&type=template&id=6accdc06"
import script from "./QuestionsView.vue?vue&type=script&lang=js"
export * from "./QuestionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6accdc06')) {
      api.createRecord('6accdc06', component.options)
    } else {
      api.reload('6accdc06', component.options)
    }
    module.hot.accept("./QuestionsView.vue?vue&type=template&id=6accdc06", function () {
      api.rerender('6accdc06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/View/QuestionsView.vue"
export default component.exports